module.exports = __webpack_public_path__ + "static/media/madfellow.2990bb46.png";